const level = [
  [ 0,   0,   0,   0,   0,   0,   0,   0,   0,   0],
  [ 0,   0,   0,  99,  99,  99,  99,  99,   0,   0],
  [ 0,  99,  99,  99,   0,   0,   0,  99,   0,   0],
  [ 0,  99,   0,   7,  64,   8,  77,  99,   0,   0],
  [ 0,  99,   0,  64,  38,  10,  51,  99,   0,   0],
  [ 0,  99,  52,   0,   0,   0,  99,  99,   0,   0],
  [ 0,  99,  99,  99,  99,  99,  99,   0,   0,   0],
  [ 0,   0,   0,   0,   0,   0,   0,   0,   0,   0],

]

export default level